var $ = require('jquery');
var features = require('diy/util/features');

/* global diy, jimdoData */
$(document).ready(function () {

    $.construct('UpgradeBrowserMessage', function() {
        var browserVersionIE = 10,
            browserVersionFirefox = 20;

        this.init = function () {

            // if we don't need to show any messages just finish up
            if (!features("browserUpgrade")) {
                this.updateNotification(false);
                return;
            }

            if ('ontouchend' in document) {
                // we don't show anything if we are in mobile
                this.updateNotification(false);
                return;
            }

            // decide here if and what message we show and populate placeholder with actual message and links
            // if we decide to show it
            switch (true) {

                // IE //
                case $.browser.msie:
                    if (parseInt($.browser.version, 10) < browserVersionIE) {
                        this.updateNotification(true, 'upgrade', 'ie');
                    }
                    else {
                        // there is no need to show any upgrade messages so just remove the hidden message placeholder
                        this.updateNotification(false);
                        return;
                    }
                    break;

                // Firefox //
                case $.browser.mozilla:
                    if (parseInt($.browser.version, 10) < browserVersionFirefox) {
                        this.updateNotification(true, 'upgrade', 'firefox');
                    }
                    else {
                        // there is no need to show any upgrade messages so just remove the hidden message placeholder
                        this.updateNotification(false);
                        return;
                    }
                    break;

                // Chrome + Safari //
                case $.browser.webkit:
                    this.updateNotification(false);
                    return;

                default:
                    this.updateNotification(true, 'switch', 'firefox');
                    break;
            }
        },

        this.manageNotification = function(show, msgType, browserType) {
            var payload = features.getPayload("browserUpgrade");

            var n = diy.editor.notifications,
                browserNotifications = n.api.getNotificationsByType(n.Notifications.TYPE_BROWSER_UPGRADE);

            if (!show) {
                if (browserNotifications.length > 0) {
                    n.api.ready(function() {
                        n.api.deleteNotificationByType(n.Notifications.TYPE_BROWSER_UPGRADE);
                    });
                }
            } else {
                if (browserNotifications.length <= 0 && !payload.doNotShow) {
                    n.api.ready(function() {
                        n.api.createNotification({type: n.Notifications.TYPE_BROWSER_UPGRADE, payload: {
                            'msgType': msgType,
                            'browserType': browserType
                        }});
                    });
                } else {
                    if (payload.counter >= payload.counterMax) {
                        n.api.ready(function() {
                            n.api.updateNotification(browserNotifications[0].getId(), {
                                dismissed: 0,
                                payload: {
                                    browserType: browserType,
                                    msgType: msgType
                                }
                            });
                        });
                    }
                }
            }
        };

        this.updateNotification = function (show, msgType, browserType) {
            diy.editor.notifications.api.ready(function() {
                this.manageNotification(show, msgType, browserType);
            }.bind(this));
        };

    });


});



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/upgradeBrowserN.js
 ** module id = 672
 ** module chunks = 0
 **/